import template from "./search.html";
import controller from "./search.controller";

const searchComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller,
};

export default
searchComponent;
